export const MINHEIGHT = 32;
export const DEFAULT_COLOR = "#0067C0";
export const DEFAULT_BACKGROUND_COLOR = "transparent";
export const PRIMARY_COLOR = "#FFF";
export const PRIMARY_BACKGROUND_COLOR = "#0067C0";
export const PRIMARY_ACTIVE_BACKGROUND_COLOR = "#0078D4";
export const PRIMARY_DISABLED_BACKGROUND_COLOR = "rgba(0, 0, 0, 0.1858)";
export const PRIMARY_HOVER_FOCUS_BACKGROUND_COLOR = "#003E92";
